import { useContext } from "react";
import { ToastContext } from "../contexts/toastContext";
 

export function useToast() {
    const value = useContext(ToastContext);
    return value;
}